__turbopack_context__.v({
  "arrow": "StatesContainer-module-scss-module__4R9sUW__arrow",
  "header": "StatesContainer-module-scss-module__4R9sUW__header",
  "pill": "StatesContainer-module-scss-module__4R9sUW__pill",
  "root": "StatesContainer-module-scss-module__4R9sUW__root",
  "row": "StatesContainer-module-scss-module__4R9sUW__row",
  "scroller": "StatesContainer-module-scss-module__4R9sUW__scroller",
});
